'use client';
import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'py-3 bg-[rgba(13,15,28,0.92)] backdrop-blur-xl border-b border-white/[0.06]'
          : 'py-5 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <AppLogo
          text="LuckCount"
          iconName="SparklesIcon"
          size={28}
          className="text-iwhite font-display font-bold text-xl tracking-tight"
        />

        <nav className="hidden md:flex items-center gap-8">
          {['Feed', 'Explore', 'How It Works', 'About']?.map((item) => (
            <a
              key={item}
              href="#"
              className="text-sm font-medium text-white/60 hover:text-iwhite transition-colors duration-200 font-body"
            >
              {item}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#"
            className="hidden md:block text-sm font-medium text-white/60 hover:text-iwhite transition-colors duration-200"
          >
            Sign in
          </a>
          <a
            href="#"
            className="cta-primary px-5 py-2.5 rounded-full text-sm font-display font-700 mint-glow"
          >
            Log Your Luck
          </a>
        </div>
      </div>
    </header>
  );
}